import React from 'react';
import { cn } from './cn';
import { getReservationStatus } from '../../constants/statusConfig';

// Generic pill.
export const Badge = ({ className, children, ...props }) => (
  <span
    className={cn(
      'inline-flex items-center justify-center rounded-full px-3 py-1 text-xs font-semibold',
      className
    )}
    {...props}
  >
    {children}
  </span>
);

// Reservation status pill driven by the single status map.
export const StatusPill = ({ state, className }) => {
  const cfg = getReservationStatus(state);
  return (
    <Badge className={cn(cfg.pill, 'min-w-[100px]', className)}>{cfg.label}</Badge>
  );
};

export default Badge;
